module.exports = __webpack_public_path__ + "img/header-diamondJewelry025Carat@2x.31a6754.jpg";